import React from 'react';
import SectionHeader from './SectionHeader';
import { Reveal } from './ScrollReveal';

export default function Process() {
  const steps = [
    { num: "01", title: "Das Erstgespräch — 30 Minuten, kostenlos", body: "Kein Pitch, kein Programm. Ein ehrliches Gespräch darüber, wo Sie heute stehen, was Sie erreichen wollen — und ob ich der Richtige dafür bin. Ich sage auch Nein, wenn es nicht passt.", tag: "Kostenlos & unverbindlich" },
    { num: "02", title: "Das Probe-Board-Meeting — ein ganzer Tag, kostenlos", body: "Sie nehmen an einem echten Board Meeting teil — als Gast, ohne Commitment. Sie erleben das Format, die Gruppe, die Arbeitsweise. Danach entscheiden beide Seiten: Passt es?", tag: "Kein Risiko · Volle Erfahrung" },
    { num: "03", title: "Die gegenseitige Entscheidung", body: "Ich prüfe: Passt Ihr Profil zur bestehenden Gruppe? Ist das Ziel realistisch erreichbar? Sie prüfen: Ist Harald Suekar der richtige Sparringpartner?", tag: "Passung vor Tempo" },
    { num: "04", title: "Die Partnerschaft — € 1.500/Monat", body: "Monatliches Board Meeting. Wöchentliches 1:1 Sparring. Die Garantie: Verdoppelung des Unternehmenswertes in maximal 36 Monaten — tritt früher ein, umso besser.", tag: "€ 1.500/Monat · Garantie" }
  ];

  return (
    <section id="prozess" className="py-32 relative z-10 border-t border-brand-border">
      <div className="max-w-[1100px] mx-auto px-8">
        <SectionHeader 
          num="06" 
          eyebrow="Der Weg in den Kreis" 
          title="Vier Schritte.<br/><em class='not-italic italic text-brand-gold'>Eine Entscheidung.</em>" 
        />
        <div className="flex flex-col max-w-[900px] mx-auto">
          {steps.map((step, idx) => (
            <Reveal key={idx} delay={idx * 0.1}>
              <div className="grid grid-cols-[60px_1px_1fr] md:grid-cols-[100px_1px_1fr] gap-0 py-12 border-b border-brand-border last:border-b-0">
                <div className="font-serif text-[3.5rem] font-light text-brand-border2/30 leading-none pr-6 md:pr-12 text-right">{step.num}</div>
                <div className="bg-brand-border mx-0 md:mx-12"></div>
                <div className="pl-8 md:pl-0">
                  <div className="font-serif text-[1.6rem] font-normal text-brand-white mb-3">{step.title}</div>
                  <p className="text-[1.05rem] text-brand-muted leading-relaxed mb-5 font-light">{step.body}</p>
                  <span className="inline-block text-[0.7rem] font-bold tracking-[0.15em] uppercase text-brand-gold border border-brand-gold/30 px-4 py-1.5 rounded-sm">
                    {step.tag}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}